import React, { FC, useContext, useEffect, useState } from "react";
import { Context } from "./index";
import { observer } from "mobx-react-lite";
import AppRoutes from "./router/AppRoutes";
import Navbar from "./components/Navbar/Navbar";
import { Layout, ConfigProvider } from "antd";
import useLocalStorage from "./hooks/use-localStorage";
import i18next from "./i18next";
import { Loader } from "./components/Loader";
import { AppFooter } from "./components/Footer";
import "./App.css";

const App: FC = () => {
  const { authStore } = useContext(Context);
  const [language, setLanguage] = useLocalStorage("language", "en");
  const [currentTheme, setCurrentTheme] = useState<string>("light");

  const lightTheme = {
    colorPrimary: "#5f6955",
    colorBgBase: "white ",
    colorPrimaryBg: "#e6f7ff",
    colorBgLayout: "#5f6955",
  };

  const darkTheme = {};

  const handleLanguageChange = (e: string) => {
    const lang = e;
    i18next.changeLanguage(e);
    setLanguage(e);
  };

  useEffect(() => {
    if (localStorage.getItem("RbkAccessToken")) {
      authStore.checkAuth();
    }
  }, []);

  if (authStore.isLoading) {
    return <Loader />;
  }
  const { Header, Content } = Layout;

  return (
    <ConfigProvider
      theme={{
        token: currentTheme === "light" ? lightTheme : darkTheme,
      }}
    >
      <Layout>
        <Header
          style={{
            background: "#5f6955",
            boxShadow: "1px 1px 25px",
            padding: "0 25px",
          }}
        >
          <Navbar
            handleLanguageChange={handleLanguageChange}
            language={language}
          />
        </Header>
        <Content>
          <AppRoutes />
        </Content>
        <AppFooter />
      </Layout>
    </ConfigProvider>
  );
};

export default observer(App);
